import {type UIStoreBodyController} from './UIStoreBodyController.ts'

export abstract class UIStoreController {
    abstract bodyController: UIStoreBodyController
    abstract headerCoinsContainer: HTMLDivElement
}
